/* eslint-disable security/detect-object-injection */
/* eslint-disable padding-line-between-statements */

import { Icon, Loader, useModal } from '@jutro/components';
import { ServiceManager } from '@jutro/legacy/services';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { LobIconUtil } from '@xengage/gw-portals-util-js';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
// import { useAciUtil } from 'ent-capability-hooks';
import messages from './BillingSummaryPage.messages';
import metadata from './BillingSummaryPage.metadata.json5';
import styles from './BillingSummaryPage.module.scss';
import BillingSummary from '../BillingSummary/BillingSummary';

const getTabHeader = (productCode, label = '') => {
    const icon = LobIconUtil.getMaterialIcon(productCode);

    return (
        <div id={`divFor${productCode}${label}`} className={styles.tabContent}>
            {productCode ? (
                <Icon
                    id={`iconFor${productCode}${label}`}
                    icon={icon}
                    title={label}
                />
            ) : null}
            <span className={styles.invoiceTab} id={`labelFor${productCode}${label}`}>
                {label.toUpperCase()}
            </span>
        </div>
    );
};

function BillingSummaryPage(props) {
    const { showAlert } = useModal();

    const { match, authHeader, history } = props;
    const { params } = match;
    const { streamId } = params;
    const localeService = ServiceManager.getService('locale-service');
    const defaultCurrencyCode = localeService
        .getDefaultCurrencyCode()
        .toUpperCase();

    const { AccountBillingDetailsService: BillingService } = useDependencies(
        'AccountBillingDetailsService'
    );
    // const { getSyncedPaymentInstrumentsForAccount } = useAciUtil();

    // screen states
    const [isLoadingData, updateIsLoadingData] = useState(true);
    const [selectedInvoiceStreamId, updateSelectedInvoiceStreamId] = useState(streamId);
    const [selectedInvoiceStream, updateSelectedInvoiceStream] = useState({});
    const [selectedCurrency, updateSelectedCurrency] = useState(defaultCurrencyCode);
    const [activeTab, updateActiveTab] = useState(selectedInvoiceStreamId);

    // fetched data
    const [accountBillingSummaryFromApi, setAccountBillingSummaryFromApi] = useState({});
    const [invoiceStreamDetailsMapFromApi, setInvoiceStreamDetailsMapFromApi] =  useState(new Map());
    const [scrollToHistorySection, setScrollToHistorySection] = useState(0);
    const [selectedPolicyNumber, setSelectedPolicyNumber] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [paymentPlan, setPaymentPlan] = useState('');
    const [screen, updateScreen] = useState('');

    const [paymentInstrumentsAllAccounts, setPaymentInstrumentsAllAccounts] = useState([]);
    const [paymentInstruments, setPaymentInstruments] = useState([]);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [tokenFromACI, updateTokenFromACI] = useState('');
    const [selectedInvoicesForPaymentFromACI, updateSelectedInvoicesForPaymentFromACI] = useState([]);

    const { accountLevelBilling = false, invoiceStreams = [] } =
        accountBillingSummaryFromApi;

    const updateMap = useCallback(
        invoiceStreamId => fetchData => {
            setInvoiceStreamDetailsMapFromApi(
                invoiceStreamDetailsMapFromApi.set(invoiceStreamId, fetchData)
            );
            
            setAccountNumber(fetchData.accountNumber_TWIA);
            setPaymentPlan(fetchData.paymentPlan_TWIA);

            const { totalValue } = fetchData;
            const { currency } = totalValue;

            updateSelectedCurrency(currency.toUpperCase());
        },
        [invoiceStreamDetailsMapFromApi]
    );

    const handleManagePaymentMethods = useCallback((event) => {
        // Let's get to ManagePayment Methods page..
        history.push(event);
    }, [ history ]);

    // eslint-disable-next-line consistent-return
    const fetchAccountLevelInvoiceStreams = useCallback(async () => {
        try {
            const accountInvoiceStreams = ! _.isEmpty(accountBillingSummaryFromApi) ? accountBillingSummaryFromApi : 
                await BillingService.getAccountInvoiceStreamInformation(authHeader);
            const {
                accountLevelBilling: accountLevelBillingFromApi = false,
                invoiceStreams: invoiceStreamsFromApi = [],
            } = accountInvoiceStreams;
            setPaymentInstrumentsAllAccounts(accountInvoiceStreams.accountPaymentInstruments);
            let defaultInvoiceStreamId;
           
            if (invoiceStreamsFromApi.length > 0) {
                defaultInvoiceStreamId = invoiceStreamsFromApi[0].internalId;
                updateSelectedInvoiceStream( invoiceStreamsFromApi[0]);
                setSelectedPolicyNumber(invoiceStreamsFromApi[0].label);
                updateActiveTab(invoiceStreamsFromApi[0].internalId);
            } else if ( accountLevelBillingFromApi &&  invoiceStreamsFromApi.length === 1 ) {
                // select the only element available..
                defaultInvoiceStreamId = invoiceStreamsFromApi[0].internalId;
                updateSelectedInvoiceStreamId( invoiceStreamsFromApi[0].internalId );
                updateSelectedInvoiceStream( invoiceStreamsFromApi[0]);
                setSelectedPolicyNumber(invoiceStreamsFromApi[0].label);
                updateActiveTab(invoiceStreamsFromApi[0].internalId);
            }
            setAccountBillingSummaryFromApi(accountInvoiceStreams);               
            return { defaultInvoiceStreamId, selectedPolicyNumber, accountInvoiceStreams };
        } catch(e) {
                showAlert({
                    title: messages.failedToLoadPolices,
                    message:
                        messages.sorryWeCanNotLoadYourPolicyInformationAtThisTime,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                }).then(() => {
                    history.push('/home');
                }, _.noop);
        }
    }, [accountBillingSummaryFromApi, BillingService, authHeader, selectedPolicyNumber, showAlert, history]);

    const getPaymentDetailsGroupFromMap = useCallback(
        invoiceStreamId => invoiceStreamDetailsMapFromApi.get(invoiceStreamId),
        [invoiceStreamDetailsMapFromApi]
    );

    const fetchInvoiceDetailsByStreamId = useCallback(
        (invoiceStreamId, forceRefresh = false) => {
            const invoiceDetails =
                getPaymentDetailsGroupFromMap(invoiceStreamId);
            let invoiceDetailsPromise;

            if (
                (invoiceStreamId && _.isEmpty(invoiceDetails)) ||
                forceRefresh
            ) {
                invoiceDetailsPromise = BillingService.getInvoiceStreamDetails(
                    invoiceStreamId,
                    authHeader
                )
                    .then(updateMap(invoiceStreamId))
                    .catch(() => {
                        showAlert({
                            title: messages.failedToLoadPolices,
                            message:
                                messages.sorryWeCanNotLoadYourPolicyInformationAtThisTime,
                            status: 'error',
                            icon: 'mi-error-outline',
                            confirmButtonText: commonMessages.ok,
                        }).then(() => {
                            history.push('/home');
                        }, _.noop);
                    });
            } else {
                invoiceDetailsPromise = Promise.resolve(invoiceDetails);
            }

            return invoiceDetailsPromise;
        },
        [getPaymentDetailsGroupFromMap, BillingService, authHeader, updateMap, showAlert, history]
    );

    const selectedLobCode = useMemo(() => {
        const foundInvoiceStreams = invoiceStreams.filter( item => item.internalId === selectedInvoiceStreamId );
        return foundInvoiceStreams.length > 0  ? foundInvoiceStreams[0].lobcode  : undefined;
    }, [invoiceStreams, selectedInvoiceStreamId]);


    const onTabClick = useCallback(
        invoiceStreamIdFromTabId => {
            fetchInvoiceDetailsByStreamId(invoiceStreamIdFromTabId).finally(
                () => {
                    updateActiveTab(invoiceStreamIdFromTabId);
                    updateSelectedInvoiceStreamId(invoiceStreamIdFromTabId);
                    updateSelectedInvoiceStream(invoiceStreams.filter( item => item.internalId === invoiceStreamIdFromTabId ))
                }
            );
        },
        [fetchInvoiceDetailsByStreamId, invoiceStreams]
    );

    const reloadInvoiceDetails = useCallback(invoiceStreamId => {
            updateIsLoadingData(true);

            return fetchInvoiceDetailsByStreamId(invoiceStreamId, true).finally(
                () => {
                    updateIsLoadingData(false);
                }
            );
        },
        [fetchInvoiceDetailsByStreamId]
    );
      
    const fetchData = useCallback(async () => {
        updateIsLoadingData(true);

        const results = await fetchAccountLevelInvoiceStreams();

        let initStreamId;
        const searchParams = new URLSearchParams(window.location.search);
        const redirectedPolicyNoFromOffers = history.location.state?.policyNumber 
        let redirectedPolicyNo = searchParams?.get("streamId");
        const state = searchParams?.get("state");
        const enableAutoPay = searchParams?.get("enableAutoPay");
        const payInvoices = searchParams?.get("payInvoices");
        const tokenId = searchParams?.get("tokenId");
        let retState;

        if (!_.isNull(state)){
            retState = JSON.parse(window.atob(window.decodeURIComponent(state)));
            redirectedPolicyNo = retState.policyNumber;
        }
        updateTokenFromACI(tokenId);

        // We are being redirected to billingSummary...this is either autopay or payment
        // if no state exists in the url then we need to redirect to autopay 
        if (!_.isNull(enableAutoPay)){
            // redirect from Turn Off Autopay, Disable enable autopay scenarios.
            // policy number is getting updated vai the streamId variable above.
            updateScreen('autoPay');
        }
        else if (!_.isNull(payInvoices)){
             // we are coming back from PayNow from Make a payment invoice screen from billing summary
            // get the policy Number from the returned variable.
            redirectedPolicyNo = searchParams?.get("policyNumber");              
            updateScreen('payment');
        }
        else  if (_.isNull(state) && !_.isEmpty(searchParams?.toString())){               
            updateScreen('autoPay');
        } else  if (!_.isNull(state) && !_.isEmpty(searchParams?.toString())){        
            updateSelectedInvoicesForPaymentFromACI(retState.selectedInvoicesList);      
            updateScreen('payment');
        }

        // Use policy number From Renewal Offer Screen OR Redirect from ACI from Invoices or setup autopay - if it exist 
        const getPolicyNumberFromRedirect = redirectedPolicyNoFromOffers || redirectedPolicyNo;

        if (redirectedPolicyNoFromOffers) {
            setScrollToHistorySection(true);
        } else {
            setScrollToHistorySection(false);
        }

        if (getPolicyNumberFromRedirect) {
            const is = results?.accountInvoiceStreams?.invoiceStreams;
            initStreamId = is?.find(a=>a.label === getPolicyNumberFromRedirect)?.internalId;
            setSelectedPolicyNumber(getPolicyNumberFromRedirect);
        }else {
            initStreamId = results.defaultInvoiceStreamId;
            setSelectedPolicyNumber(results.selectedPolicyNumber);
        }            

        fetchInvoiceDetailsByStreamId(initStreamId).finally(() => {
            onTabClick(initStreamId);
            updateIsLoadingData(false);
        });
    }, [fetchAccountLevelInvoiceStreams, fetchInvoiceDetailsByStreamId, history.location.state?.policyNumber, onTabClick]);

    useEffect(() => {
        if (authHeader){
            fetchData();
        }
    // DE18331 remove function calls from useEffect, creates duplicate calls
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authHeader]);

    useEffect(() => {
        if (!_.isEmpty(paymentInstrumentsAllAccounts) &&  accountNumber) {
           
            let filteredResp;
            if (!_.isEmpty(window.location.search)) {               
                let paymentInstrumentTokenId;
                const searchParams = new URLSearchParams(window.location.search);
                const tokenId = searchParams.get("tokenId");
                // Returning from ACI  - check if payment instrument is added.  
                if (!_.isNil(tokenId)) {
                    paymentInstrumentTokenId = tokenId;
                } 
                // Filter out all single use payment instruments except for the newly added one if it was single use
                filteredResp = paymentInstrumentsAllAccounts[accountNumber].filter(pi => pi.singleUse === false  || pi.token === paymentInstrumentTokenId);
                // Payment Instrument wasn't added
            } else {
                // Filter out all single use payment instruments
                filteredResp = paymentInstrumentsAllAccounts[accountNumber].filter(pi => pi.singleUse === false);
            }
            
            setPaymentInstruments(_.sortBy(filteredResp, 'description'));
            updateIsLoadingData(false);
        
        }
    }, [authHeader, accountNumber, paymentInstrumentsAllAccounts]);

    const noData = useCallback(() => invoiceStreams.length === 0, [invoiceStreams]);

    if (isLoadingData) {
        return <Loader loaded={!isLoadingData} />;
    }

    const overrideProps = {
        noDataMessageContainer: {
            visible: noData(),
            message: messages.noBillingData,
        },
        billingSummaryContainer: {
            visible: !noData(),
        },
        billingTabsId: {
            content: _.map(invoiceStreams, item => ({
                    id: item.internalId,
                    type: 'element',
                    component: 'tab',
                    componentProps: {
                        heading: getTabHeader(item.lobcode, item.label),
                    },
                    content: [
                        {
                            id: `billingContentFor${item.internalId}`,
                            type: 'container',
                            component: BillingSummary,
                            componentProps: {
                                policyNumber: selectedPolicyNumber,
                                accountLevelBilling,
                                invoiceStreamId: selectedInvoiceStreamId,
                                lobCode: selectedLobCode,
                                paymentGroupDetails: getPaymentDetailsGroupFromMap( selectedInvoiceStreamId ),
                                accountNumber,
                                paymentPlan,
                                currency: selectedCurrency,
                                reloadInvoiceDetails,
                                invoiceStream: selectedInvoiceStream,
                                selectedInvoicesForPaymentFromACI,
                                history,
                                selectSubMenu: screen,
                                // tokenFromACI,
                                scrollToHistorySection,
                                paymentInstruments
                            },
                        },
                    ],
                })),
            activeTab,
            onTabChange: onTabClick,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap:{
            handleManagePaymentMethods
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers}
        />
    );
}

BillingSummaryPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            streamId: PropTypes.string,
        }),
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};

export default withAuthenticationContext(withRouter(BillingSummaryPage));
